/**
 * Users/Index Controller
 *
 * 
 */
 
 // the constructor for this object
 function UsersEditUserController() { }
 
// the object
UsersEditUserController.prototype = {
    constructor: UsersEditUserController,
    
    // The user ID of the user we're going to be editing
    editingUserId: '',
    
    // initialize the controller
    init: function() 
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();
        
        this.editingUserId = PortalMain.getRouteSegments()[0];
        PortalHelper.debugMessage('Edit User Controller Initialized');
    },

    // run the controller
    run: function()
    {
        // register the events used by this controller
        this._registerEvents();
        
        // can the user edit accounts
        if (this._userHasAdminAccounts()) {
            
            // get the uses info
            this._getUserInfo();
        }
        
        PortalHelper.debugMessage('Edit User Controller Ran');
    },

    // register the javascript events
    _registerEvents:  function() 
    {   
        var self = this;
        $('#edit-user-form').on('submit', function(e) {
            e.preventDefault();
            
            self._updateUserInfo();
        });
        
        // check all column event
        $('th.check-all-column').on('click', function() {
            var columnIndex = $(this).index();
            PortalMain.UsersEditUserController._checkAllInColumn(columnIndex);
        });
        
        // initiate password reset
        $('#send-password-reset').on('click', function() {
            PortalHelper.disableButton('#send-password-reset');
            PortalMain.UsersEditUserController._sendPasswordReset();
        });
    },
    
    // Utilizes the API to bring in info for the user we're currently editing. Calls populateTable to put all of that info into our table
    _getUserInfo: function()
    {
        PortalHelper.loadingOverlay('#edit-user-form', true);
        PortalHelper.loadingOverlay('#user-details', true);
        var self = this;
        var userInfoRequest = new PortalRequest;
        userInfoRequest.errorElement = '#edit-user-form .form-errors';
        userInfoRequest.makeRequest(
            '/users/get-user',
            {
                userId: this.editingUserId,
            },
            function(response) {
                PortalHelper.loadingOverlay('#edit-user-form', false);
                PortalHelper.loadingOverlay('#user-details', false);
                PortalHelper.enableButton('#update-user-info');
                self._populateTable(response);
            },
            function() {
                PortalHelper.disableButton('#update-user-info');
                $('#edit-user-form .form-errors').append('<br> Redirecting...');
                setTimeout(function () {
                    window.location.href = PortalConfig.portalUrl + '/users/';
                }, 3000);   
            }
        )
    },
    
    // Populates the table with the information of the user we're editing, and what accounts they have access to
    _populateTable: function(response)
    {    
        // Update the user information
        $('#user-details .name .value').html(response.first_nm + ' ' + response.last_nm);
        $('#user-details .email .value').html(response.email_nm);
        
        var editingUserAccounts = response.accounts_users;
        var portalUserAccounts = PortalMain.PortalAccounts.getAdminAccounts();
        var portalUserAccountIds = PortalHelper.getAdminAccountIDs();
        
        // Create rows for each account we have access to
        for(var i in portalUserAccounts) {
            var currentAcct = portalUserAccounts[i];
            var newRow = $('tr.clone-source').clone();
            newRow.removeClass('hidden').removeClass('clone-source');
            newRow.attr('data-account-id', currentAcct.account_id);
            newRow.find('input[type="radio"]').each(function(i, e) {
                $(e).attr('name', 'account-'+currentAcct.account_id);
            });
            newRow.find('.account-number').text(currentAcct.account_number);
            newRow.find('.account-name').text(currentAcct.name);
            $('table.accounts').append(newRow);
        }
        
        // Populate the fieldsets of accounts that the user being edited already has some sort of access to
        for(var i in editingUserAccounts) {
            var currentAcct = editingUserAccounts[i];
            if(portalUserAccountIds.includes(currentAcct.account_id)) {
                var accountFieldset = $('[data-account-id="' + currentAcct.account_id + '"]');
                if(currentAcct.is_account_admin) {
                    accountFieldset.find('.admin-access').prop("checked",true);
                } else {
                    accountFieldset.find('.user-access').prop("checked",true);
                }
            }
        }
    },
    
    // Calls the API to update the user's information, including account access
    _updateUserInfo: function()
    {
        PortalHelper.loadingOverlay('#edit-user-form', true);
        PortalHelper.loadingOverlay('#user-details', true);
        var updatedAccounts = [];
        var customerAccts = $('[data-account-id]');
        
        customerAccts.each(function(i, e){
            updatedAccounts.push(
                {
                    account_id: $(this).attr('data-account-id'),
                    access_level: $(this).find('input[type="radio"]:checked').val(),
                }
            );
        });
        
        var updateUserRequest = new PortalRequest();
        updateUserRequest.successElement = '#edit-user-form .form-success';
        updateUserRequest.errorElement = '#edit-user-form .form-errors';
        updateUserRequest.makeRequest(
            '/users/update-user',
            {
                userId: this.editingUserId,
                accounts: updatedAccounts,
                
            },
            function(response) {
                PortalHelper.loadingOverlay('#edit-user-form', false);
                PortalHelper.loadingOverlay('#user-details', false);
                PortalHelper.disableButton('#update-user-info');
                $('.form-success').append('<br> Redirecting...');
                
                setTimeout(function () {
                    window.location.href = PortalConfig.portalUrl + '/users/';
                }, 3000);                
            },
            function(response) {
                PortalHelper.loadingOverlay('#edit-user-form', false);
                PortalHelper.loadingOverlay('#user-details', false);
            }
        );
    },
    
    // Checks if the user has administrator access to any customer accounts. 
    _userHasAdminAccounts: function()
    {
        var portalUserAccountIds = PortalHelper.getAdminAccountIDs();
        
        // Return if the user has no admin access to any customer accounts
        if(portalUserAccountIds.length == 0) {
            $('#edit-user-form').html('Your account does not have permission to edit this user');
            PortalHelper.loadingOverlay('#edit-user-form', false);
            PortalHelper.loadingOverlay('#user-details', false);
            return false;
        } 
        
        return true;
    },
    
    // check all inputs in the provided column index
    _checkAllInColumn: function(columnIndex)
    {
        $('table.accounts tbody tr:not(.clone-source) td').each(function() {
            var cellIndex = $(this).index();
            if (cellIndex == columnIndex) {
                $('input', this).prop('checked', true);
            }
        });
    },
    
    // send the user a reset password email
    _sendPasswordReset: function() 
    {
        var email = $('#user-details .email .value').html();
        
        PortalHelper.loadingOverlay('#password-reset-form', true);
        var forgotRequest = new PortalRequest;
        forgotRequest.errorElement = '#password-reset-form .form-errors';
        forgotRequest.makeRequest(
            '/auth/forgot-password',
            {
                email: email,
            },
            function(data, code, message) {
                $('#password-reset-form .form-success').removeClass('hidden');
            }
        );
        PortalHelper.loadingOverlay('#password-reset-form', false);
    },
    
 }